// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"532":"styles","678":"component---src-pages-index-js","774":"framework","883":"component---src-pages-404-js"}[chunkId] + "-" + {"532":"b862c625657626239daa","678":"31cddb7992800d4b3fa1","774":"08b06bdc66eb048eee86","883":"14b2e86b6b5696cfed51"}[chunkId] + ".js";
};